import React from 'react';
import './index.scss';
import LangNav from '../lang-nav';
import BrandLogo from "../../atoms/brand-logo";
import Button, {ButtonType} from "../../atoms/button";

export interface HeaderTopProps {
    authenticated: boolean;
    authenticatedAndOnboarded: boolean;
    employerUnit: string|null;
}

const HeaderTop = ({ authenticated, authenticatedAndOnboarded, employerUnit }: HeaderTopProps) => {
    const baseClassName = 'm-header-top';
    const isOnboardingPage = authenticated && !authenticatedAndOnboarded;

    return (
        <div className={`${baseClassName} ${!authenticated ? '-anonymous' : ''} ${authenticatedAndOnboarded ? 'd-none d-lg-block' : ''}`}>
            <div className="container-lg">
                <div className={`${baseClassName}__container ${authenticatedAndOnboarded ? 'd-none d-lg-flex' : 'd-flex'}`}>
                    <div className={`${baseClassName}__logo  col-lg-2 ${authenticatedAndOnboarded ? 'd-none d-lg-flex' : 'd-flex'}`}>
                        <a href="/">
                            <BrandLogo/>
                        </a>
                    </div>
                    <div className={`${baseClassName}__info_section col-lg-10`}>
                        <div className={`${baseClassName}__employerUnit`}>
                            {null !== employerUnit && (
                                <>{window.sv_resource.get('header_employer_unit')} {employerUnit}</>
                            )}
                        </div>
                        {!isOnboardingPage && (
                            <div className={`${baseClassName}__langnav`}>
                                <LangNav/>
                            </div>
                        )}
                        {isOnboardingPage && (
                            <Button className={'logout-button'} text={window.sv_resource.get('11')} href="/_logout" type={ButtonType.Gray} hasArrow={false}/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderTop;
